import { cn, getStatusColor } from '@/lib/utils';
import type { LucideIcon } from 'lucide-react';

interface StatusBadgeProps {
  /** Status string (ACTIVE, INACTIVE, pending, etc.) */
  status: string;
  /** Optional icon rendered before the label */
  icon?: LucideIcon;
  /** Override display label (defaults to status with underscores replaced) */
  label?: string;
  className?: string;
}

/**
 * Colour-coded status badge with optional icon.
 *
 * ```tsx
 * <StatusBadge status="ACTIVE" icon={Shield} />
 * <StatusBadge status="pending" label="Awaiting" />
 * ```
 */
export function StatusBadge({ status, icon: Icon, label, className }: StatusBadgeProps) {
  const displayLabel = label ?? status.replace(/_/g, ' ');

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium',
        getStatusColor(status),
        className
      )}
    >
      {Icon && <Icon className="h-3 w-3" />}
      {displayLabel}
    </span>
  );
}
